// Sem saldo próprio no desembolso a rentabilidade não é definida; dividir geraria ∞% no resumo.
export const calculateFundingProfitability = (netDeduction: number, accountBalance: number): number => {
    if (!(accountBalance > 0)) {
        return 0;
    }

    return netDeduction / accountBalance;
};
